import PropTypes from 'prop-types';

const displayName = 'RefundPolicy';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
